import { useEffect, useState } from 'react';
import MenuTooltip from './MenuTooltip';
import { AddIcon, DeleteIcon } from 'components/icons';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import sty from '../styles/Roles.module.css';
import { array, bool, func } from 'prop-types';

/**
 * @component RoleHeader
 * @param { Object } props
 * @param { Array } props.options
 * @param { boolean } props.isDisabled
 * @param { Array } props.selected
 * @param { function } props.onOptions
 * @param { function } props.onAdd
 * @param { function } props.onDelete
 * @returns { JSX.Element }
 */
function RoleHeader(props) {
	const [values, setValues] = useState([]);

	useEffect(() => {
		setValues(props.selected);
	}, [props.selected]);

	return (
		<section className={sty.role_header_section}>
			<Autocomplete
				fullWidth
				multiple
				disableCloseOnSelect
				value={values}
				options={props.options}
				getOptionLabel={(option) => option.name}
				isOptionEqualToValue={(option, value) => option.name === value.name}
				onChange={(e, newValues) => props.onOptions(newValues)}
				renderInput={(params) => (
					<TextField
						{...params}
						label="Roles"
						variant="outlined"
						size="small"
						InputLabelProps={{ shrink: true }}
					/>
				)}
			/>
			<div className={sty.role_header_tooltips}>
				<MenuTooltip
					title="Add Role(s)"
					disabledTitle="Select Role(s)"
					disabled={props.IsDisabled.add}
					onClick={props.onAdd}
					icon={<AddIcon />}
				/>
				<MenuTooltip
					title="Delete Role(s)"
					disabledTitle="Select Checkbox"
					disabled={props.IsDisabled.delete}
					onClick={props.onDelete}
					icon={<DeleteIcon />}
				/>
			</div>
		</section>
	);
}

RoleHeader.propTypes = {
	options: array,
	isDisabled: bool,
	selected: array,
	onOptions: func,
	onAdd: func,
	onDelete: func,
};

export default RoleHeader;
